<template>
  <div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{
        background: '#B1B1B1',
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '18px',
      }"
      :cell-style="{ textAlign: 'center' }"
    >
      <el-table-column type="index" label="序号" width="100px">
      </el-table-column>
      <el-table-column prop="XM" label="姓名"> </el-table-column>
      <el-table-column prop="SSDW" label="单位"> </el-table-column>
      <el-table-column prop="VIPZW" label="职务"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [
          {
            XM: "王小虎",
            SSDW: "广东中一司法鉴定中心",
            VIPZW: "副主任",
          }
        ];
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less"></style>
